import css from './sortable-item.module.scss';
import {useSortable} from '@dnd-kit/sortable';
import {CSSProperties} from 'react';
import {Song} from '../../song/song';
import {CSS} from '@dnd-kit/utilities';
import {SortableItemProps} from './sortable-item.types';

export const SortableItem = ({id, draggable, song}: SortableItemProps) => {
	const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id});

	const sortableItemStyle: CSSProperties = {
		transform: CSS.Transform.toString(transform),
		transition,
		boxShadow: isDragging ? '0px 0px 10px 5px #8a8a8a4a' : 'none',
		zIndex: isDragging ? 4 : 0,
	};

	const grabStyle: CSSProperties = {
		visibility: draggable ? 'visible' : 'hidden',
	};

	const dragIcon = (
		<div className={css.dragHandler} style={grabStyle} {...attributes} {...listeners}>
			<div>
				<img src="img/hamburger.svg" width={15} />
			</div>
		</div>
	);

	return (
		<div className={css.container} ref={setNodeRef} style={sortableItemStyle}>
			{dragIcon}
			<Song {...song} />
			{/* <div className={css.border}></div> */}
		</div>
	);
};
